import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import classes from './Assessment.module.css'
import { isJson } from '../../../utils'
import moment from "moment";
import useCheckedDate from "../hooks/useCheckedDate";
import { onKeyDown } from "../service";
import DynamicMessage from "../UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../models/DynamicMessageTypeEnum";
import { useParams } from "react-router-dom";
import { useMapStyle } from "../hooks/useMapStyle";
import { ProgressMapIslandTypes } from "../models/ProgressMapIslandTypes";
import SvgComponent from "../UI/SvgComponent/SvgComponent";

// const Assessment = ({ dataAssessment, dataLesson, positions, toggelEye }) => {
const Assessment = ({ handleShowLessonViewer, aiCourse, dataAssessment, dataLesson, positions, studyGroupId, setMessagePopup }) => {
    const { applictionName } = useParams();
    const uiData = useSelector((state) => state.general.uiData);
    const lessonesListType = uiData[applictionName].lessonesListType;
    const [close, setClose] = useState(true)
    const [assigmentStatus, setAssigmentStatus] = useState({});

    const { direction, texts } = useSelector((state) => state.translate);
    const starsRange = useMemo(() => [[0, 55, 0], [55, 75, 1], [75, 90, 2], [90, 101, 3]], [])
    const starsRangeFilter = dataAssessment && dataAssessment.submission ? starsRange.filter(r => dataAssessment.submission.scoreAdditionalData >= r[0] && dataAssessment.submission.scoreAdditionalData < r[1]) : []
    const starsNum = starsRangeFilter.length > 0 ? starsRangeFilter[0][2] : 0
    const status = { Rejected: texts.Rejected, Started: texts.work, Submitted: "✔", Completed: "✔" }
    const { svgEnrichmentImgOnIsland } = useMapStyle();
    const checkDate = useCheckedDate()
    // useEffect(() => {
    //     setClose(toggelEye)
    // }, [toggelEye])

    const getMark = () => {
        if (dataAssessment && dataAssessment.submission && dataAssessment.submission.scoreAdditionalData && isJson(dataAssessment.submission.scoreAdditionalData)) {
            const res = JSON.parse(dataAssessment.submission.scoreAdditionalData)
            return res && res.ScoreType === "numScore" ? res.weightedScore : null
        }
        return null
    }

    const clickAssignmentHref = () => {
        if (dataLesson.activeFromDate && checkDate(new Date(dataLesson.activeFromDate), new Date(dataLesson.currentDate), new Date(dataLesson.ClientDate), new Date()) || dataLesson.active) {
            handleShowLessonViewer(dataLesson.id)
        }
        else {
            let contentText = ''
            if (dataLesson.activeFromDate)
                contentText = `${texts.messageLockedLesson} ${moment(dataLesson.activeFromDate).format("DD.MM.YY")}`
            setMessagePopup && setMessagePopup(<DynamicMessage
                type={DynamicMessageTypeEnum.Warn}
                title={texts.theLessonLocked}
                content={contentText}
                confirmText={texts.iUnderstand}
                confirmFunc={() => setMessagePopup(null)}
                showCancel={false} />)
        }
    }

    useEffect(() => {
        setAssigmentStatus({
            close: close,
            lockedAssignment: dataLesson.activeFromDate && new Date(dataLesson.activeFromDate) > new Date(dataLesson.currentDate) || !dataLesson.active && !dataLesson.activeFromDate,
            submissionStatus: dataAssessment && dataAssessment.submission,
            isLate: dataLesson.isLate,
            assignmentContest: dataLesson.lessonType.includes(ProgressMapIslandTypes.contest),
        })
    }, [close, dataLesson, dataAssessment])

    return (
        <React.Fragment>
            {/* {dataLesson && <NavLink className={classes.AssignmentHref} to={`/studyGroup/${studyGroupId}/lesson/${dataLesson.id}`}> */}
            {dataLesson && <div
                className={`${classes[direction]} ${close? classes.AssignmentHrefClose: classes.AssignmentHref}`}
                style={{ left: `${positions.left}px`, top: `${positions.top}px` }}
                onClick={clickAssignmentHref}>
                {/* <div className={`${classes.Assignment} ${close && toggelEye && classes.Close}  */}
                <SvgComponent name={close ? "assessment" : "border"}
                    size={"100%"}
                    className={`${classes.AssignmentBG}  
                    ${assigmentStatus.close && classes.CloseBG} 
                    ${assigmentStatus.lockedAssignment ? classes.LockedAssignmentBG : ''}
                    ${assigmentStatus.submissionStatus ? classes[`Assignment${dataAssessment.submission.submissionStatus}BG`] : ''}
                    ${assigmentStatus.isLate && classes.AssignmentLateBG} 
                    ${assigmentStatus.assignmentContest ? classes.AssignmentContestBG : ''}`}
                />

                <div
                    className={`${classes.Assignment} 
                    ${assigmentStatus.close && classes.Close} 
                    ${assigmentStatus.lockedAssignment ? classes.LockedAssignment : ''}
                    ${assigmentStatus.submissionStatus ? classes[`Assignment${dataAssessment.submission.submissionStatus}`] : ''}
                    ${assigmentStatus.isLate && classes.AssignmentLate} 
                    ${assigmentStatus.assignmentContest ? classes.AssignmentContest : ''}`}
                    onMouseLeave={() => setClose(true)} onMouseEnter={() => setClose(false)}
                    tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, clickAssignmentHref)}
                >

                    <div className={classes.Part1}>
                        <div className={`${classes.scoreAdditionalData} ${classes[`Score${starsNum}`]}`}></div>
                        {!aiCourse ? (
                            <div className={classes.AssignmentAlias}>
                                {!dataLesson.lessonType.includes(ProgressMapIslandTypes.enrichment)
                                    ? dataLesson.indexOnMap
                                    : svgEnrichmentImgOnIsland[(dataLesson.indexOnMap % 10) - 1]}
                            </div>
                        ) : (
                            <div className={classes.AssignmentAlias}>
                                {!dataLesson.lessonType.includes(ProgressMapIslandTypes.contest) ? (
                                    dataLesson.indexOnMap
                                ) : (
                                    <img src={uiData.aiCourses?.svgIslandsImgsArr[(dataLesson.indexOnMap % uiData.aiCourses.svgIslandsImgsArr.length) - 1]}
                                        alt={`AI Island ${dataLesson.indexOnMap}`} />
                                )}
                            </div>
                        )}

                        <div className={classes.AssignmentName}>{dataLesson.name}</div>
                    </div>
                    <div className={`${classes.AssignmentTags} ${classes[`AssignmentTags${dataLesson.indexOnMap % 10}`]}`}>
                        <div className={classes.Part2}>
                            {dataAssessment && dataAssessment.submission && <div className={`${classes.AssignmentTag} ${classes[`AssignmentTag_${dataAssessment.submission.submissionStatus}`]}`}>{status[dataAssessment.submission.submissionStatus]}</div>}
                            {/* {getMark() && <div className={`${classes.AssignmentTag} ${classes[`AssignmentTag_mark`]}`}>{getMark()}</div>} */}
                            {dataLesson.isLate && !getMark() && <div className={`${classes.AssignmentTag} ${classes.AssignmentTag_late}`}>{texts.late}</div>}
                        </div>
                    </div>
                    {dataAssessment && dataAssessment.submission && (dataAssessment.submission.submissionStatus === "Submitted" || dataAssessment.submission.submissionStatus === "Completed") ? <div className={`${classes.AssignmentTag} ${classes[`AssignmentTag_Submitted`]}`}>✔</div> : <React.Fragment></React.Fragment>}
                </div>
            </div>}
            {/* </NavLink>} */}
        </React.Fragment >

    )
}

export default Assessment